import {
  NameSpecifiedEntity
} from "../entity";

/**
 * 削除フラグについてはログイン時のみ取得・確認しているが、他の処理では未対応
 */
export class Department extends NameSpecifiedEntity<string> {
  constructor(id: string, name: string, public shortName: string, public isDeleted: boolean = false) {
    super(id, name);
  }

  clone(): Department {
    return new Department(this.id, this.name, this.shortName, this.isDeleted);
  }
}
